/* RESPONSIBLE TEAM: team-automation-foundations */
import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type Transition from '@ember/routing/-private/transition';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import { taskFor } from 'ember-concurrency-ts';

export default class FinAiAgentSalesLeadsRoute extends Route {
  @service declare intl: IntlService;
  @service declare permissionsService: $TSFixMe;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare appService: AppService;

  get titleToken() {
    return this.intl.t('ai-agent.analyze.leads.title');
  }

  async beforeModel(transition: Transition) {
    this.permissionsService.ensurePermissionWhenTransitioning('can_access_reporting', transition);

    if (!this.appService.app.canUseFinSalesAgent) {
      transition.abort();
      this.transitionTo('apps.app.automation.fin-ai-agent.sales.performance');
      return;
    }

    await taskFor(this.reportingMetrics.setup).perform();
  }
}
